import {
  GetPersonalNoteResult,
  PostPersonalNoteResult,
} from "#/services/rest/gwt/exam-results/personal-note/personal-note.api";
import { errorToastOption } from "@monta/components";
import type { ModalProps } from "@monta/design-system";
import {
  Button,
  Modal,
  TextArea,
  Toast,
  useBreakLG,
} from "@monta/design-system";
import { ChatColorful, Close } from "@monta/icons";
import clsx from "clsx";
import { useEffect, useMemo, useState } from "react";
import styles from "./personalNoteModal.module.scss";

type TPersonalNoteModalProps = ModalProps & {
  questionId: number;
};
const PersonalNoteModal = (props: TPersonalNoteModalProps) => {
  const [value, setValue] = useState("");

  const { mutate: defaultNoteMutate, data: defaultNote } =
    GetPersonalNoteResult.useMutation({
      onSuccess: (res) => {
        setValue(res);
      },
    });

  useEffect(() => {
    if (props.isOpen) {
      defaultNoteMutate({ body: { questionId: Number(props.questionId) } });
    }
  }, [defaultNoteMutate, props]);

  const { mutate, isLoading } = PostPersonalNoteResult.useMutation({
    onSuccess: (result) => {
      if (result) {
        Toast.success({
          message: "یادداشت شما با موفقیت ثبت شد",
        });
        props.close();
      } else Toast.error(errorToastOption);
    },
    onError: () => {
      Toast.error(errorToastOption);
    },
  });
  const isLG = useBreakLG();

  const charCount = useMemo(() => {
    return (
      <span
        className={
          styles[
            "modal-container__bottom-section__textfield-container__char-count"
          ]
        }
      >
        {value.length + " / 100"}
      </span>
    );
  }, [value]);

  const submit = () => {
    if (value.length < 101) {
      mutate({
        body: { questionId: Number(props.questionId), description: value },
      });
    } else {
      Toast.error({
        message: "یادداشت شخصی خود را وارد کنید",
      });
    }
  };

  return (
    <>
      <Modal {...props} maxWidth={600} bottomSheetOnMobile borderRadius="4">
        <div className={clsx(styles["modal-container"])}>
          <div className={clsx(styles["modal-container__top-section"])}>
            <div
              className={clsx(
                styles["modal-container__top-section__title-container"],
              )}
            >
              <ChatColorful />
              <span
                className={
                  styles["modal-container__top-section__title-container__title"]
                }
              >
                {isLG ? "یادداشت شخصی" : "یادداشت"}
              </span>
            </div>
            <Close
              color="#8C8787"
              className={
                styles["modal-container__top-section__title-container__close"]
              }
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.close();
              }}
            />
          </div>
          <div className={clsx(styles["modal-container__bottom-section"])}>
            <div
              className={clsx(
                styles["modal-container__bottom-section__subtitle"],
              )}
            >
              ایده‌ها و نکات مهم را یادداشت کنید، این یادداشت ها{" "}
              <b>فقط برای شما قابل مشاهده است</b> و می توانند مرور آزمون را آسان
              تر کنند.
            </div>
            <div
              className={clsx(
                styles["modal-container__bottom-section__textfield-container"],
              )}
            >
              <TextArea
                nodetail
                className={clsx(
                  styles[
                    "modal-container__bottom-section__textfield-container__textfield"
                  ],
                )}
                maxLength={100}
                placeholder="ایده‌ها و نکات مهم را بنویسید..."
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
              {charCount}
            </div>
            <div
              className={clsx(
                styles["modal-container__bottom-section__buttons"],
              )}
            >
              <Button
                borderRadius="4"
                height={58}
                color="#475467"
                width={94}
                onClick={() => {
                  props.close();
                  setValue(defaultNote || "");
                }}
              >
                انصراف
              </Button>
              <Button
                borderRadius="4"
                color="#fff"
                bgColor="primary-600"
                height={58}
                width={186}
                loading={isLoading}
                onClick={submit}
              >
                ثبت
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default PersonalNoteModal;
